import { useEffect, useState, useRef } from "react";

export function useCountDown(initCount: number, trigger: boolean) {
  const [count, setCount] = useState(initCount);
  const timer = useRef<NodeJS.Timer>();

  useEffect(() => {
    if (trigger) {
      timer.current = setInterval(() => {
        setCount((prev) => {
          const next = prev - 1;
          if (next >= 0) {
            return next;
          }
          if (next <= 0) {
            window.clearInterval(timer.current);
          }
          return 0;
        });
      }, 1000);
    } else {
      setCount(initCount);
    }
  }, [initCount, trigger]);

  return {
    count,
  };
}
